
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.168.86a1.13 1.13 0 01.984.027c.329.164.547.383.711.71.164.329.164.657.028.985L9.668 13.957c-.219.438-.52.684-.93.766-.41.082-.793 0-1.12-.246-.329-.22-.493-.575-.493-1.04V8.625H2.312c-.464 0-.82-.164-1.039-.492-.246-.328-.328-.711-.246-1.121.082-.41.328-.711.766-.93L13.168.859z"}})])
          )
        }
      }
    